import * as types from 'constants/ActionTypes';
import { OFFERS_API_URL } from 'constants/ApiConstants';

import OfferService from '../services/api/OfferService';

// OFFERS
const copyOfferRequest = offerId => ({
  type: types.COPY_OFFER_REQUEST,
  offerId,
});

const copyOfferFailure = error => ({
  type: types.COPY_OFFER_FAILURE,
  error,
});

const copyOfferSuccess = offer => ({
  type: types.COPY_OFFER_SUCCESS,
  offer,
});

export const copyOffer = offerId => dispatch => {
  dispatch(copyOfferRequest(offerId));
  return new Promise((resolve, reject) => {
    OfferService.copyOffer(offerId)
      .then(response => {
        dispatch(copyOfferSuccess(response.data));
        resolve(response.data);
      })
      .catch(error => {
        dispatch(copyOfferFailure(error));
        reject(error);
      });
  });
};

// DELETE
const deleteOfferRequest = offerId => ({
  type: types.DELETE_OFFER_REQUEST,
  offerId,
});

const deleteOfferFailure = error => ({
  type: types.DELETE_OFFER_FAILURE,
  error,
});

const deleteOfferSuccess = offerId => ({
  type: types.DELETE_OFFER_SUCCESS,
  offerId,
});

export const deleteOffer = offerId => dispatch => {
  dispatch(deleteOfferRequest(offerId));
  return new Promise((resolve, reject) => {
    OfferService.deleteOffer(offerId)
      .then(() => {
        dispatch(deleteOfferSuccess(offerId));
        resolve();
      })
      .catch(error => {
        dispatch(deleteOfferFailure(error));
        reject(error);
      });
  });
};

// EXPORT
export const exportOffers = (email, language, customer, reference) => ({
  type: types.EXPORT_OFFERS_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${OFFERS_API_URL}/export`,
      params: {
        email,
        language,
        customer,
        reference,
      },
    },
  },
});

export const exportOffersFailure = error => ({
  type: types.EXPORT_OFFERS_FAILURE,
  error,
});

export const exportOffersSuccess = () => ({
  type: types.EXPORT_OFFERS_SUCCESS,
});

export const fetchOffer = (offerId, params) => ({
  type: types.FETCH_OFFER_REQUEST,
  offerId,
  params,
});

export const fetchOfferFailure = error => ({
  type: types.FETCH_OFFER_FAILURE,
  error,
});

export const fetchOfferSuccess = offer => ({
  type: types.FETCH_OFFER_SUCCESS,
  offer,
});

export const fetchOffers = (links, params) => ({
  type: types.FETCH_OFFERS_REQUEST,
  links,
  params,
});

export const fetchOffersFailure = error => ({
  type: types.FETCH_OFFERS_FAILURE,
  error,
});

export const fetchOffersSuccess = (offers, page, links) => ({
  type: types.FETCH_OFFERS_SUCCESS,
  offers,
  page,
  links,
});

export const getPdfSpecs = (id, filename) => ({
  type: types.FETCH_OFFER_SPECS_PDF_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${OFFERS_API_URL}/${id}/pdf`,
      params: { simplified: true },
    },
  },
  meta: { filename },
});

export const getPdfOfferSpecsFailure = message => ({
  type: types.FETCH_OFFER_SPECS_PDF_FAILURE,
  payload: { message },
  error: true,
});

export const getPdfOfferSpecsSuccess = () => ({
  type: types.FETCH_OFFER_SPECS_PDF_SUCCESS,
});

// SAVE
const saveOfferRequest = offer => ({
  type: types.SAVE_OFFER_REQUEST,
  offer,
});

const saveOfferFailure = error => ({
  type: types.SAVE_OFFER_FAILURE,
  error,
});

const saveOfferSuccess = offer => ({
  type: types.SAVE_OFFER_SUCCESS,
  offer,
});

export const saveOffer = offer => dispatch => {
  dispatch(saveOfferRequest(offer));
  return new Promise((resolve, reject) => {
    OfferService.saveOffer(offer)
      .then(response => {
        dispatch(saveOfferSuccess(response.data));
        resolve(response.data);
      })
      .catch(error => {
        dispatch(saveOfferFailure(error));
        reject(error);
      });
  });
};

// SELECT
export const selectOffer = offerId => ({
  type: types.SELECT_OFFER,
  offerId,
});

export const cleanOffers = () => ({
  type: types.CLEAN_OFFERS,
});

export const displaySettingsModal = () => ({
  type: types.DISPLAY_SETTINGS_MODAL,
});

export const hideSettingsModal = () => ({
  type: types.HIDE_SETTINGS_MODAL,
});

export const displayCustomerCreation = () => ({
  type: types.DISPLAY_CUSTOMER_CREATION,
});

export const hideCustomerCreation = () => ({
  type: types.HIDE_CUSTOMER_CREATION,
});

export const setModalValue = data => ({
  type: types.SET_OFFER_MODAL_VALUE,
  payload: {
    data,
  },
});

export const displayConsentModal = () => ({
  type: types.DISPLAY_CONSENT_MODAL,
});

export const hideConsentModal = () => ({
  type: types.HIDE_CONSENT_MODAL,
});

export const consentOffer = () => ({
  type: types.CONSENT_OFFER,
});

export const createInterventionOffer = id => ({
  type: types.POST_INTERVENTION_OFFER,
  payload: {
    request: {
      method: 'POST',
      url: `${OFFERS_API_URL}/${id}/interventions`,
    },
  },
});

export const createInterventionOfferSuccess = payload => ({
  type: types.POST_INTERVENTION_OFFER_SUCCESS,
  payload,
});

export const createInterventionOfferFailure = error => ({
  type: types.POST_INTERVENTION_OFFER_FAILURE,
  payload: error,
  error: true,
});
